import React from "react";
import { Edges } from "@react-three/drei";
import { DoubleSide } from "three";
import { MM } from "./constants";

/**
 * Telaio perimetrale: lamiera di acciaio pressopiegata da 2 mm, verniciata a
 * polveri colore simile RAL 7016 (grigio antracite - #293133). Non e' un pezzo
 * a se' che sbalza davanti alla porta: e' letteralmente un'estensione della
 * porta stessa, quindi condivide lo stesso spessore e lo stesso piano Z (le
 * facce anteriore e posteriore coincidono con quelle del pannello) e si limita
 * ad allargarne il contorno sui montanti e sulla traversa.
 */
export const C_TELAIO_PERIMETRALE = "#293133";

// Bordo sottile a filo porta: 4 mm, coerente con il calibro della lamiera pressopiegata.
export const TELAIO_PERIMETRALE_LARGHEZZA = MM(4);

export type TelaioPerimetraleProps = {
  larghezza: number;
  altezza: number;
  spessore: number;
  // colore RAL scelto per il telaio (es. #F6F6F6 per RAL 9016); di serie C_TELAIO_PERIMETRALE
  colore?: string;
};

export const TelaioPerimetrale: React.FC<TelaioPerimetraleProps> = ({ larghezza, altezza, spessore, colore }) => {
  const L = TELAIO_PERIMETRALE_LARGHEZZA;

  const mat = { color: colore ?? C_TELAIO_PERIMETRALE, side: DoubleSide, roughness: 0.6, metalness: 0.25 } as const;

  return (
    <>
      {/* Montante sinistro */}
      <mesh position={[-L / 2, altezza / 2, 0]}>
        <boxGeometry args={[L, altezza + L, spessore]} />
        <meshStandardMaterial {...mat} />
        <Edges color="#999999" />
      </mesh>

      {/* Montante destro */}
      <mesh position={[larghezza + L / 2, altezza / 2, 0]}>
        <boxGeometry args={[L, altezza + L, spessore]} />
        <meshStandardMaterial {...mat} />
        <Edges color="#999999" />
      </mesh>

      {/* Traversa superiore */}
      <mesh position={[larghezza / 2, altezza + L / 2, 0]}>
        <boxGeometry args={[larghezza, L, spessore]} />
        <meshStandardMaterial {...mat} />
        <Edges color="#999999" />
      </mesh>
    </>
  );
};
